import * as React from 'react';
import { Grid, Box } from '@mui/material';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { url, urlLive } from "../../constant";

function ChangePassword() {
    // State for password fields
    const [currentPassword, setCurrentPassword] = React.useState('');
    const [newPassword, setNewPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');

    // State for validation errors
    const [errors, setErrors] = React.useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
    });

    // State for API response and loading status
    const [isloading, setIsLoading] = React.useState(false);
    const [apiError, setApiError] = React.useState("");
    const [apiSuccess, setApiSuccess] = React.useState("");

    // State for API response and loading status
    const [loading, setLoading] = React.useState(false);

    // Form validation
    const validateForm = () => {
        const newErrors = { currentPassword: "", newPassword: "", confirmPassword: "" };
        let isValid = true;

        if (!currentPassword) {
            newErrors.currentPassword = "Password attuale è obbligatoria";
            isValid = false;
        }

        if (!newPassword) {
            newErrors.newPassword = "Nuova Password è obbligatoria";
            isValid = false;
        } else if (newPassword !== confirmPassword) {
            newErrors.confirmPassword = "Le password non coincidono";
            isValid = false;
        }

        setErrors(newErrors); // Set all errors at once
        return isValid;
    };

    // Handle form submission
    const handleSubmit = async () => {
        if (validateForm()) {

            setLoading(true);
            setIsLoading(true);
            setApiError("");
            setApiSuccess("");

            // Prepare the form data
            var akLogId = JSON.parse(localStorage.getItem('user'));
            const formdata = new FormData();
            formdata.append("log_id", akLogId.user.IdUser);
            formdata.append("current_password", currentPassword);
            formdata.append("new_password", newPassword);
            formdata.append("new_password_confirmation", confirmPassword);

            // Retrieve JWT token from localStorage
            const storedUser = localStorage.getItem('user');
            const token = storedUser ? JSON.parse(storedUser).access_token : null;

            if (!token) {
                setApiError("Authorization token is missing.");
                setIsLoading(false);
                return;
            }

            const myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${token}`); // Use the JWT token from localStorage

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: formdata,
                redirect: "follow"
            };

            try {
                const response = await fetch(`${url}auth/change-password`, requestOptions);
                const result = await response.json();

                if (response.ok) {

                    // Clear user info (password) from localStorage after successful password change
                    localStorage.removeItem('user'); // or clear specific parts if needed, like the password
                    // Redirect to home page
                    window.location.href = '/authentication/sign-in';  // or use your preferred route if using React Router

                    setApiSuccess("Password modificata");
                } else {
                    setApiError(result.error || "An error occurred.");
                }
            } catch (error) {
                setApiError("Network error: " + error.message);
            } finally {
                setLoading(false);
                setIsLoading(false);
            }
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox style={{ backgroundColor: 'white', minHeight: '85vh' }} py={6}>
                <MDBox px={2} mx={2} mt={2}>
                    <Grid container spacing={3} justifyContent="center">
                        <Grid item xs={12} sm={8} md={6} lg={6}>
                            <MDBox mb={3} textAlign="center">
                                <MDTypography variant="h4" fontWeight="bold" color="text">
                                    {/* Change Your Password */}
                                    Cambio password
                                </MDTypography>
                                <MDTypography variant="body2" color="textSecondary">
                                    {/* Please enter your current password, then set a new one. */}
                                    Inserisci la password attuale e poi la nuova.
                                </MDTypography>
                            </MDBox>

                            {/* Password Form Fields */}
                            <MDBox mt={4} sx={{ borderRadius: 2, padding: 4, boxShadow: 2 }}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        {/* Current Password */}
                                        <TextField
                                            // label="Current Password"
                                            label="Password Attuale"
                                            type="password"
                                            variant="outlined"
                                            fullWidth
                                            value={currentPassword}
                                            onChange={(e) => setCurrentPassword(e.target.value)}
                                            error={!!errors.currentPassword}
                                            helperText={errors.currentPassword}
                                            sx={{
                                                '& .MuiInputBase-root': { height: '40px' },
                                                '& .MuiFormLabel-root': { fontSize: '14px' },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        {/* New Password */}
                                        <TextField
                                            // label="New Password" 
                                            label="Nuova password"
                                            type="password"
                                            variant="outlined"
                                            fullWidth
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            error={!!errors.newPassword}
                                            helperText={errors.newPassword}
                                            sx={{
                                                '& .MuiInputBase-root': { height: '40px' },
                                                '& .MuiFormLabel-root': { fontSize: '14px' },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        {/* Confirm New Password */}
                                        <TextField
                                            // label="Confirm New Password"
                                            label="Conferma nuova password"
                                            type="password"
                                            variant="outlined"
                                            fullWidth
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            error={!!errors.confirmPassword}
                                            helperText={errors.confirmPassword}
                                            sx={{
                                                '& .MuiInputBase-root': { height: '40px' },
                                                '& .MuiFormLabel-root': { fontSize: '14px' },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        {/* Action Buttons */}
                                        <Stack spacing={2} direction="row" justifyContent="flex-end">
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={handleSubmit}
                                                disabled={isloading}
                                                sx={{
                                                    borderRadius: '8px',
                                                    height: '40px',
                                                    fontSize: '14px',
                                                    fontWeight: 'bold',
                                                    color: '#fff',
                                                    // backgroundColor: '#007BFF',
                                                    // '&:hover': {
                                                    //     backgroundColor: '#0056b3',
                                                    // },
                                                    backgroundColor: '#183759', // 💙 Base background color
                                                    '&:hover': {
                                                        backgroundColor: '#204b80', // ✨ Slightly lighter hover
                                                    },
                                                }}
                                            >
                                                {/* {isloading ? "Saving..." : "Save Changes"} */}
                                                {isloading ? "Saving..." : "Salva"}
                                            </Button>
                                        </Stack>
                                    </Grid>

                                    {/* Display API Errors or Success Messages */}
                                    {apiError && (
                                        <Grid item xs={12}>
                                            <MDTypography variant="body2" color="error">
                                                {apiError}
                                            </MDTypography>
                                        </Grid>
                                    )}

                                    {apiSuccess && (
                                        <Grid item xs={12}>
                                            <MDTypography variant="body2" color="success">
                                                {apiSuccess}
                                            </MDTypography>
                                        </Grid>
                                    )}
                                </Grid>
                            </MDBox>
                        </Grid>
                    </Grid>
                </MDBox>
            </MDBox>

            {/* Loader - Backdrop */}
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Footer />
        </DashboardLayout>
    );
}

export default ChangePassword;
